import React from 'react';
import { Form, Checkbox, Button, Typography } from 'antd';

const { Title } = Typography;
const samplePDF = "https://firebasestorage.googleapis.com/v0/b/operataxis.firebasestorage.app/o/DriverRegistration%2FComplaint%20Handling%20Procedure.pdf?alt=media&token=e71df8bd-b4ad-46b7-a2e7-241fd3d0f8c9"

const Step12 = ({ form, next, prev }) => {
  const handleSubmit = () => {
    form
      .validateFields()
      .then(values => {
        next(); 
      })
      .catch(errorInfo => {
        console.log('Validation Failed:', errorInfo);
      });
  };

  return (
    <Form form={form} layout="vertical" style={{ maxWidth: 800, margin: '0 auto' }}>
      <Title level={2}>Complaint Handling Procedure</Title>
      <div style={{ height: "500px", border: "1px solid #ccc", marginBottom: "20px" }}>
        <iframe
          src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(samplePDF)}`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="PDF Viewer"
        />
      </div>

      <Form.Item
        name="Complaint"
        valuePropName="checked"
        rules={[{ required: true, message: 'Please confirm you have read the driver training material.' }]}
      >
        <Checkbox  onChange={(e) => {
      form.setFieldsValue({
        Complaint: e.target.checked ? "agree" : undefined,
      });
    }}>I have read and understood the Complaint Handling Procedure.</Checkbox>
      </Form.Item>

      <Form.Item style={{ textAlign: 'center' }}>
        <Button onClick={prev} style={{ marginRight: 8 }}>
          Back
        </Button>
        <Button type="primary" onClick={handleSubmit}>
          Next
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Step12; 